module.exports = __webpack_public_path__ + "img/more.d9734985.svg";